import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { IconName } from '../../icons-container/icons.type';
import { ComponentVariant, Variants } from '../variant/variant';

@Component({
  selector: 'rt-empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.background-fade]': 'backgroundFade',
    '[class.no-content-margin]': '!hasContentMargin',
    '[class]': 'variant',
  },
})
export class EmptyStateComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'small',
      'with-background',
      'with-white-background',
      'v-centered',
      'with-padding-top',
      'heading-large-x',
      'heading-margin-top-small',
    ],
  ];
  @ComponentVariant(EmptyStateComponent.VARIANTS)
  @Input()
  public variant: string;
  @Input() public title: string;
  @Input() public titleIcon: IconName;
  @Input() public desc: string;
  @Input() public icon: IconName;
  @Input() public imageUrl: string;
  @Input() public backgroundFade: boolean;
  @Input() public hasContentMargin: boolean = true;
  @Input() public fixedImageDimensions?: { width: string; height: string };
}
